import React from 'react'
import { propContainerWidth, tableProps, tdProps } from './helpersProps'

export const TableWrapper = ({children, ...rest}) => (
    <table {...{...tableProps, ...rest}}>
        <tbody>
            {children}
        </tbody>
    </table>
)

export const TableWrapperButton = ({children, width, background, backgroundGradient = false, border = false, borderRadius = false}) => (
    <table className="emailButton" {...tableProps} width={width} style={{backgroundColor: background, ...(backgroundGradient && {background: backgroundGradient}), ... (border && {border: border}), ... (borderRadius && {borderRadius: borderRadius})}}>
        <tbody>
            <tr>
                {children}
            </tr>
        </tbody>
    </table>
)

export const CenteringContainer = ({children}) => (
    <td {...tdProps}>
        <TableWrapper>
            <tr>
                <td {...tdProps}>
                    {children}
                </td>
            </tr>
        </TableWrapper>
    </td>
)

export const FlexibleContainer = ({children, addTableStyles = {}, width, ...rest}) => (
    <table className="flexibleContainer" style={addTableStyles}  {...{...tableProps, ...rest, width: width}}>
        <tbody>
            {children}
        </tbody>
    </table>
)

export const FlexibleContainerCell = ({children, addClass='', addStyles={}, width, ...rest}) => (
    <td className={'flexibleContainerCell' + (addClass ? ' ' + addClass : '')} {...{...tdProps, ...rest, width: width}} style={addStyles}>
        {children}
    </td>
)

export const NewsletterSectionRow = ({children, addTdClass='', addTdStyles={}, addTableStyles = {}, width=propContainerWidth.width}) => (
    <tr>
        <CenteringContainer>
            <FlexibleContainer width={width} addTableStyles={addTableStyles}>
                <tr>
                    <FlexibleContainerCell width={width} addClass={addTdClass} addStyles={addTdStyles}>
                        {children}
                    </FlexibleContainerCell>
                </tr>
            </FlexibleContainer>
        </CenteringContainer>
    </tr>
)